module.exports = __webpack_public_path__ + "img/icon-arrow.3664bda5.svg";